import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import { Extern } from 'src/app/models/extern.model';
import { ExternService } from 'src/app/services/extern.service';

@Component({
    selector: 'app-delete-breed',
    templateUrl: './delete.component.html',
    styleUrls: ['./delete.component.scss'],
    standalone: false
})
export class DeleteExternComponent implements OnInit {

	@Input('extern') extern: Extern | null;
	public loading = false;
	constructor(
		protected dialogRef: NbDialogRef<DeleteExternComponent>,
		protected router: Router,
		protected externService: ExternService
	) { }

	ngOnInit(): void { }

	public deleteAction(): void {
		if (!this.extern) return;

		this.loading = true;
		this.externService.delete(this.extern.id).subscribe(
			done => {
				this.dialogRef.close({ deleted: true });
			}
		);
	}

	public closeAction(): void {
		this.dialogRef.close({ deleted: false });
	}
}
